import {Product, WishlistCollection} from '../../@types/wishlist.js';

export enum HeadRenderCase {
  RenderCollectionHead = 'RENDER_COLLECTION_HEAD',
  RenderNothing = 'NOTHING',
}

export enum ProductsRenderCase {
  RenderNothing = 'NOTHING',
  RenderCollectionEmptyUnfiltered = 'RENDER_COLLECTION_EMPTY_UNFILTERED',
  RenderProducts = 'RENDER_PRODUCTS',
  RenderEmptyFiltered = 'RENDER_EMPTY_FILTERED',
  RenderEmptyFilteredExternalNotification = 'RENDER_EMPTY_FILTERED_EXTERNAL_NOTIFICATION',
}

export class WishlistRenderCase {
  headRenderCase: HeadRenderCase;
  productsRenderCase: ProductsRenderCase;

  private constructor(headRenderCase: HeadRenderCase, productsRenderCase: ProductsRenderCase) {
    this.headRenderCase = headRenderCase;
    this.productsRenderCase = productsRenderCase;
  }

  static determineRenderCase(
    productsOfComponent: Product[],
    filteredProducts: Set<Product>,
    wishlistCollection?: WishlistCollection,
  ): WishlistRenderCase {
    const headRenderCase = this.determineHeadRenderCase(wishlistCollection);
    if (productsOfComponent.length === 0) {
      return new WishlistRenderCase(
        headRenderCase,
        wishlistCollection ? ProductsRenderCase.RenderCollectionEmptyUnfiltered : ProductsRenderCase.RenderNothing
      );
    }

    if (filteredProducts.size > 0) {
      return new WishlistRenderCase(headRenderCase, ProductsRenderCase.RenderProducts);
    }

    if (this.isExternalNotificationCase()) {
      return new WishlistRenderCase(
        headRenderCase,
        ProductsRenderCase.RenderEmptyFilteredExternalNotification
      );

    }
    return new WishlistRenderCase(headRenderCase, ProductsRenderCase.RenderEmptyFiltered);
  }

  private static isExternalNotificationCase(): boolean {
    const externalNotificationCase = new URL(window.location.href).searchParams.get('btp_kw');
    return externalNotificationCase?.toLowerCase() === 'Wishlist-Shortage'.toLowerCase()
      || externalNotificationCase?.toLowerCase() === 'Wishlist-Reduction'.toLowerCase()
      || externalNotificationCase?.toLowerCase() === 'Wishlist-Reminder'.toLowerCase();
  }

  private static determineHeadRenderCase(wishlistCollection?: WishlistCollection) {
    if (wishlistCollection) {
      return HeadRenderCase.RenderCollectionHead;
    } else {
      return HeadRenderCase.RenderNothing;
    }
  }
}
